export const CarRequestStatus = {
    "created": "Created",
    "requested": "Requested",
    "calculation": "Calculation",
    "waiting_for_client": "Waiting for client",
    "inspection": "Inspection",
    "inspected": "Inspected",
    "buying_procedures": "Buying procedures",
    "buy": "Buy",
    "export_procedures": "Export procedures",
    "car_in_port": "Car in port",
    "exported": "Exported",
    "canceled": "Canceled"
}
